import { EcommerceStrategyIcon, TravelTourismStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Planning to Experience: Our Travel & Tourism Software
               Development Process
            </h2>

            <p className="section_desc">
               We have been building travel and tourism software for over 12 years, focused on creating smooth, flexible, and reliable tools. Our approach helps improve customer experience, reduce daily friction, and simplify how travel operations are managed.
            </p>

            <TravelTourismStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
